import { SIZES } from 'constants/common';

/**
 * @type {function}
 * @desc An utility function to do [something]
 * @example
 * import { computeSize } from 'utils/computeSize';
 * const result = computeSize( ...args );
 */
export const computeSize = ( size ) => {
	switch ( size ) {
		case 'xs':
		case 'XS':
		case 'Extra-small':
		case SIZES.EXTRA_SMALL: {
			return SIZES.EXTRA_SMALL;
		}

		case 's':
		case 'S':
		case 'Small':
		case SIZES.SMALL: {
			return SIZES.SMALL;
		}

		case 'm':
		case 'M':
		case 'Medium':
		case SIZES.MEDIUM: {
			return SIZES.MEDIUM;
		}

		case 'l':
		case 'L':
		case 'Large':
		case SIZES.LARGE: {
			return SIZES.LARGE;
		}

		case 'xl':
		case 'XL':
		case 'Extra-large':
		case SIZES.EXTRA_LARGE: {
			return SIZES.EXTRA_LARGE;
		}

		default: {
			return null;
		}
	}
};
